import React from 'react'
import CustomEditor from './CustomEditor'
import _ from "lodash";
import { Input } from "semantic-ui-react";

export default class InputEditor extends CustomEditor {

  attachRef = (ref) => this.input = ref;

  afterGuiAttached() {
    const char = _.get(this, "props.charPress");
  _.invoke(this, "input.focus");
    const charRegex = _.get(this, "props.charRegex", /.*/);
    if(!char || !charRegex.test(char)) {
      _.invoke(this, "input.select");
    }
  }

  getValue() {
    return _.invoke(this, "props.parseValue", _.get(this, "input.value", ""));
  }

  render() {
    const val = _.get(this, "props.value");
    const def = _.chain(this).get("props.charPress").defaultTo(val).value();
    let inputProps = {};
    if (this.props && this.props.isControlledInput) {
      inputProps.value = this.props.value;
    } else {
      inputProps.defaultValue = _.get(this, "props.charRegex", /.*/).test(def) ? def : val;
    }
    return (
      <input
        ref={this.attachRef}
        type='text'
        className='form-control'
        {...inputProps}
        defaultValue={_.get(this, "props.charRegex", /.*/).test(def) ? def : val}
        onBlur={this.props.onBlur}
        onKeyDown={this.props.handleInput}
        onKeyUp={this.props.onKeyUp}
        onChange={this.props.onChange}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./components/product-detail/InputEditor.js